<template>
  <BaseModal v-model="show" title="添加 / 编辑广告" :width="540">
    <FormModel :model="form.config" :rules="rules" labelAlign="left" :action="submit"
               :label-col="{span: 5}" :wrapper-col="{span: 19}" v-on="$listeners">
      <a-form-model-item label="广告标题" prop="name">
        <a-input v-model="form.config.name" placeholder="请输入广告标题"/>
      </a-form-model-item>
      <a-form-model-item label="广告图片" prop="rs_id">
        <ImageUpload v-model="form.config.rs_id" :width="390"/>
      </a-form-model-item>
      <a-form-model-item label="广告链接" prop="link">
        <a-input v-model="form.config.link" placeholder="请输入完整的http广告跳转链接，非必填"/>
      </a-form-model-item>
      <a-form-model-item label="文案描述" prop="desc">
        <a-textarea v-model="form.config.desc" placeholder="宣传文案，不超过250个字符，非必填" rows="5"/>
      </a-form-model-item>
    </FormModel>
  </BaseModal>
</template>

<script>
import api from "@/utils/api";
import func from "@/utils/func";
import BaseModal from "@/comps/BaseModal";
import FormModel from "@/comps/FormModel";
import ImageUpload from "@/comps/ImageUpload";

export default {
  name: "AdvertForm",
  props: {albumId: String},
  components: {ImageUpload, FormModel, BaseModal},
  data() {
    return {
      show: false,
      form: {
        id: "",
        config: {
          name: "",
          rs_id: "",
          link: "",
          desc: "",
          extend: {},
        }
      },
      rules: {
        name: {required: true, message: "请输入广告标题"},
        rs_id: {required: true, message: "请上传广告资源"},
      },
    }
  },
  methods: {
    open(advert) {
      this.show = true;
      if (advert) {
        this.form = func.copyObject(advert);
      } else {
        this.form = {id: "", config: {name: "", rs_id: "", link: "", desc: "", extend: {}}};
      }
    },
    submit() {
      this.form.config.type = 1; // TODO 图片
      return func.imageSize(func.imageUrl(this.form.config.rs_id))
          .then(size => {
            this.form.config.extend = {width: size.w.toString(), height: size.h.toString()};
            let promise = this.form.id
                ? api.v1.album.advert.update(this.albumId, this.form.id, this.form.config)
                : api.v1.album.advert.create(this.albumId, this.form.config);
            return promise.then(() => this.show = false);
          });
    }
  }
}
</script>

<style scoped>

</style>